<template>
    <div class="padding">
        <div class="flex flex-between flex-v-center" style="padding: 0 10px;">
            <h4>{{ $t('批改作业') }}</h4>
            <div class="flex flex-v-center" style="position: relative;top:40px">
                <el-input style="border-radius: 20px;" :placeholder="$t('请输入老师名称')" v-model="name">
                    <el-button slot="append" icon="el-icon-search"></el-button>
                </el-input>
            </div>
        </div>

        <div style="padding: 0 10px;" class="margin-t">
            <el-tabs v-model="status" @tab-click="getList()">
                <el-tab-pane label="待批改" name="0"></el-tab-pane>
                <el-tab-pane label="已完成" name="1"></el-tab-pane>
            </el-tabs>
        </div>

        <el-table :header-cell-style="{ background: '#f5f7fa', color: '#333', 'border-radius': '4px' }" class="margin-t"
            :data="tableData" style="width: 100%">
            <el-empty slot="empty" :description="$t('还没有批改作业数据')" style="margin-top: 100px;"></el-empty>
            <el-table-column align="center" prop="nickName" :label="$t('学生信息')">
            </el-table-column>
            <el-table-column align="center" prop="created_at" :label="$t('提交时间')" width="160px">
            </el-table-column>
            <el-table-column align="center" prop="name" :label="$t('批改老师')">
            </el-table-column>

            <el-table-column align="center" prop="clazz_name" :label="$t('班级名称')">
            </el-table-column>
            <el-table-column align="center" prop="title" :label="$t('作业标题')">
            </el-table-column>
            <el-table-column align="center" v-if="status == 1" prop="latest_homework" :label="$t('批改时间')">
            </el-table-column>

            <el-table-column prop="address" :label="$t('操作')">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" @click="open(scope.row)">{{ scope.row.status == 1 ? $t('查看') :
                        $t('批改')
                    }}</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog fullscreen v-if="dalogVisible" custom-class="br" :visible.sync="dalogVisible"
            :close-on-click-modal="false" :show-close="false" width="30%" center>
            <h4 slot="title">{{ workItem.title }}</h4>

            <el-row :gutter="40">
                <el-col :span="12">
                    <el-card shadow="never">
                        <h3 slot="header">{{ $t('学生作答') }}</h3>
                        <div>{{ workItem.content }}</div>
                        <div v-for="(item1, i) in workItem.attachment" :key="i">
                            <el-divider></el-divider>
                            <div class="flex flex-between flex-v-center">
                                <audio controls v-if="item1.type == 'audio'" :src="$host + item1.url"></audio>
                                <el-image :preview-src-list="[$host + item1.url]" v-else-if="item1.type == 'image'"
                                    style="height: 100px;width: 200px;" fit="cover" :src="$host + item1.url"></el-image>
                                <el-link v-else-if="item1.type == 'file'">{{ item1.url.split('/').pop() }}</el-link>

                                <div class="flex flex-v-center">
                                    <el-tooltip :content="$t('下载')">
                                        <el-button @click="remove_attachment(i)" style="font-size: 25px;" type="text"
                                            icon="el-icon-download"></el-button>
                                    </el-tooltip>
                                </div>
                            </div>

                        </div>
                        <el-divider></el-divider>
                        <el-form ref="form" label-position="top" :model="form" label-width="80px">

                            <el-form-item prop="content">
                                <template slot="label">
                                    <span>{{ $t('作答内容') }}</span>
                                </template>

                                <audio controls v-if="record.content.endsWith('.wav')"
                                    :src="$host + record.content"></audio>
                                <el-input v-else readonly type="textarea" :rows="6" :placeholder="$t('请输入作业内容')"
                                    v-model="record.content">
                                </el-input>
                            </el-form-item>
                        </el-form>

                    </el-card>

                </el-col>

                <el-col :span="12">
                    <el-card shadow="never">
                        <h3 slot="header">{{ $t('老师批改') }}</h3>
                        <el-form ref="form" label-position="top" :model="form" label-width="80px">
                            <el-form-item prop="title">
                                <el-switch v-model="form.pass" :inactive-text="$t('不达标')"
                                    :active-text="$t('达标')"></el-switch>
                            </el-form-item>

                            <el-form-item prop="content" :rules="[
                                { required: true, message: $t('评价内容不能为空') },
                            ]" :label="$t('评价内容')">
                                <el-input type="textarea" :rows="6" :placeholder="$t('请输入评价内容')" v-model="form.content">
                                </el-input>

                                <div v-for="(item, i) in form.attachment" :key="i">
                                    <el-divider></el-divider>
                                    <div class="flex flex-between flex-v-center">
                                        <audio controls v-if="item.type == 'audio'" :src="$host + item.url"></audio>
                                        <el-image :preview-src-list="[$host + item.url]"
                                            v-else-if="item.type == 'image'" style="height: 100px;width: 200px;"
                                            fit="cover" :src="$host + item.url"></el-image>
                                        <el-link v-else-if="item.type == 'file'">{{ item.url.split('/').pop()
                                        }}</el-link>

                                        <div class="flex flex-v-center">
                                            <el-tooltip :content="$t('下载')">
                                                <el-button @click="remove_attachment(i)" style="font-size: 25px;"
                                                    type="text" icon="el-icon-download"></el-button>
                                            </el-tooltip>
                                            <el-tooltip :content="$t('移除')">
                                                <el-button @click="remove_attachment(i)" style="font-size: 25px;"
                                                    type="text" icon="el-icon-close"></el-button>
                                            </el-tooltip>
                                        </div>
                                    </div>

                                </div>

                                <div class="flex flex-v-center margin-ts">
                                    <el-upload accept="audio/mp3,audio/wav" :headers="headers" :data="uploadData"
                                        :action="action" :show-file-list="false" :on-success="handleAudioSuccess">
                                        <el-button style="font-size: 16px;" type="text" size="large"
                                            icon="el-icon-service">{{
                                                $t('添加音频') }}</el-button>
                                    </el-upload>

                                    <el-divider class="margin-x" direction="vertical"></el-divider>
                                    <el-upload accept="image/jpeg,image/jpg,image/png" :headers="headers"
                                        :data="uploadData" :action="action" :show-file-list="false"
                                        :on-success="handleImageSuccess">
                                        <el-button style="font-size: 16px;" type="text" size="large"
                                            icon="el-icon-picture">{{
                                                $t('添加图片') }}</el-button>
                                    </el-upload>
                                    <el-divider class="margin-x" direction="vertical"></el-divider>
                                    <el-upload accept=".pdf,.doc,.docx,.xls,.xlsx" :headers="headers" :data="uploadData"
                                        :action="action" :show-file-list="false" :on-success="handleFileSuccess">
                                        <el-button style="font-size: 16px;" type="text" size="large"
                                            icon="el-icon-document-add">{{
                                                $t('添加文件') }}</el-button>
                                    </el-upload>
                                </div>
                            </el-form-item>
                        </el-form>
                        <div class="margin-lt">
                            <el-divider></el-divider>
                            <el-button type="primary" @click="submit()">{{
                                record.result ? $t('重新提交') : $t('提交批改') }}</el-button>
                        </div>
                    </el-card>
                </el-col>

            </el-row>

            <span class="dialog-footer center" slot="footer">
                <el-button @click="dalogVisible = false">{{ $t('关 闭') }}</el-button>
            </span>
        </el-dialog>
    </div>
</template>


<script>
export default {
    data() {
        return {
            uploadData: null,
            action: 'https://www.ptefighter.com/api/work/upload',
            headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
            name: '',
            status: '0',
            tableData: [],
            workItem: null,
            record: null,
            dalogVisible: false,
            form: { attachment: [], pass: false }
        }
    },
    created() {
        this.getList();
    },
    methods: {
        submit() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.$http.post('/api/work/record/result', { id: this.workItem.id, result: this.form }).then(() => {
                        this.$message({
                            type: 'success',
                            message: this.$t("提交成功")
                        })
                        this.form.attachment = []
                        this.dialogVisible4 = false
                        this.get_works()
                    })
                } else {
                    return false;
                }
            });
        },

        remove_attachment(i) {
            const urls = [this.form.attachment[i].url]
            this.$http.post("/api/work/upload/remove", { urls }).then(() => {
                this.form.attachment.splice(i, 1)
            })
        },

        handleAudioSuccess(url) {
            this.form.attachment.push({
                type: 'audio',
                url
            })
        },
        handleImageSuccess(url) {
            this.form.attachment.push({
                type: 'image',
                url
            })
        },
        handleFileSuccess(url) {
            this.form.attachment.push({
                type: 'file',
                url
            })
        },

        open(item) {
            this.workItem = item;
            this.uploadData = { clazz_id: item.clazz_id }
            this.$http.post("/api/homework/record/info", { work_id: item.id }).then((record) => {
                this.record = record;
                if (record.result) {
                    this.form.pass = record.result.pass
                    this.form.content = record.result.content
                    this.form.attachment = record.result.attachment
                } else {
                    this.form.pass = false
                    this.form.content = ''
                    this.form.attachment = []
                }
                this.dalogVisible = true;
            })
        },
        getList() {
            this.$http.post('/api/work/records', { status: this.status, name: this.name }).then(data => {
                this.tableData = data;
            });
        },
        to(path) {
            this.$router.push(path);
        }
    }
};
</script>
